import React, {useEffect, useRef, useState} from 'react';
import {Chart, ArcElement} from 'chart.js'
import 'chartjs-adapter-luxon';
import MyGanttChart from "./MyGanttChart"

import {Bar} from "react-chartjs-2";
import {Doughnut} from 'react-chartjs-2';
import commaSeparator from "../../../utils/CommaSeparator";

Chart.register(ArcElement);
const AdminCharts = (props) => {
  const chartType = props.type
  const hasBorder = props.hasBorder;
  const hasPrint = props.hasPrint;

  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.height = 100;
    }
  })

  // console.log(props.title)
  //  
  const [rnd, setRnd] = useState(Math.floor(Math.random() * 10000000));
  useEffect(() => {
    setRnd(Math.floor(Math.random() * 10000000))

  }, [])


  function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
  }

  function PrintImage(id) {
     
    const temp = document.getElementById(id + "");
    temp.style.padding = '50px';
    temp.style.margin = '50px';
    // var win = window.open();
    // window.document.write("");
    document.head.remove();
    // document.append(`<head><style>@media print {size:A4 portrait !important;}</style></head>`);
    document.body.innerHTML = "";
    // document.body.innerHTML += `<head><style>@media print {size:A4 portrait !important;}</style></head>`
    const style = ``;
    document.body.append(temp);
    const here = `<style>
/*@media print {size:A4 portrait !important; {padding:20px}}*/
#${id}{
padding:150px;
background:#ff0000;

}
@page{
size:A4 portrait !important;
}
</style>`;

    // const node = createElementFromHTML(here);

    // document.body.append(node);

     
    window.print();
    window.location.reload();

  }
   

  return (

    <>
      {props.data ? <>
        <div className={props.className} id={"" + rnd}>
          <div
            className={hasBorder ? "text-center border border-black"
              :
              "text-center"
          }>{props.title} {!isNaN(props.sum) && "| جمع کل:" + commaSeparator(props.sum)}</div>
          {chartType === 'gantt' ? <>
            <MyGanttChart

              data={props.data}
              options={props.options}
            />
            {/*<Bar*/}
            {/*  ref={ref}*/}
            {/*  data={props.data}*/}
            {/*  options={props.options}*/}
            {/*  // style={{maxHeight: "50%",maxWidth: "15%"}}*/}
            {/*/>*/}
          </> : chartType === 'Bar' ? <>
            <div className={hasBorder ? "border border-black": ""}>
              <Bar
                ref={ref}
                data={props.data}
                options={props.options}
                // style={{maxHeight: "50%",maxWidth: "15%"}}
              />
            </div>
          </> : chartType === 'Doughnut' ? <div className={hasBorder ? "border border-black" : ""}>
            <Doughnut
              ref={ref}
              data={props.data}
              options={props.options}
              // style={{maxHeight: "50%",maxWidth: "15%"}}
            />
          </div> : <div>نوع چارت طبق استاندارد کامپوننت ها مشخص نشده</div>}
          {hasPrint &&
            <div onClick={() => {
              PrintImage(rnd + "")
              //  
              // const print = document.getElementById(rnd);
              // window.document.body.style.visibility = 'hidden';
              // print.style.visibility = 'block !important';
              // window.print();
              // window.close();

            }}><i className="fa fa-print" aria-hidden="true"></i></div>
          }

        </div>
      </> : <div className={props.className}>
        <div className={"text-center border border-black"}>{props.title}</div>
        <div className={"text-center border border-black"}> داده ای موجود نیست</div>
      </div>}
    </>);
};

export default AdminCharts;
